import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import PricingSummaryUpdated from './PricingSummaryUpdated';
import { getDOMContainer } from '../utils/utility.js';

export default class PricingSummaryPortal extends React.Component {
	render() {
		this.containerEl = getDOMContainer(
			document,
			'.ddc-vehicle-pricing-summary'
		);

		const {
			dealerAddress,
			viewPriceDetail,
			summary,
			prefs,
			widgetInfo,
			isMobile
		} = this.props;

		const summaryComp = (
			<PricingSummaryUpdated
				prefs={prefs}
				summary={summary}
				viewPriceDetail={viewPriceDetail}
				widgetInfo={widgetInfo}
				dealerAddress={dealerAddress}
				isMobile={isMobile}
			/>
		);

		// if there is a pricing summary, render in portal
		if (this.containerEl) {
			return ReactDOM.createPortal(summaryComp, this.containerEl);
		}

		return null;
	}
}

PricingSummaryPortal.propTypes = {
	prefs: PropTypes.shape({
		showStickySidebarLoanLease: PropTypes.string
	}).isRequired,
	summary: PropTypes.arrayOf(
		PropTypes.shape({
			_type: PropTypes.string.isRequired,
			formatted: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			value: PropTypes.number.isRequired
		})
	).isRequired,
	widgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired,
		deviceType: PropTypes.string.isRequired
	}).isRequired,
	viewPriceDetail: PropTypes.func.isRequired,
	dealerAddress: PropTypes.shape({
		address1: PropTypes.string,
		address2: PropTypes.string,
		address3: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		postalCode: PropTypes.string,
		country: PropTypes.string
	}),
	isMobile: PropTypes.bool.isRequired
};

PricingSummaryPortal.defaultProps = {
	dealerAddress: {}
};



// WEBPACK FOOTER //
// ./src/components/PricingSummaryPortal.jsx